<template>
    <div class="error">
        <div class="ot-card profile-header">
            <div class="modal-header__header">
                <img class="modal-header__header__logo" :src="$whitelabel.resources.logo" alt="logo"/>
                <div class="modal-header__header__logout">
                    <OtButton
                        class="is-text is-small"
                        @click="$router.push({name: 'login', query: $route.query})"
                        :title="'login.error.back.title'"
                    >
                        <i class="oti oti-logout ot-button-icon--left is-small"/>
                        {{ $t('login.error.back.text') }}
                    </OtButton>
                </div>
            </div>

            <div class="modal-header__content">
                <h4 class="modal-header__title">{{ $t('login.error.title') }}</h4>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import OtButton from '../components/OtButton.vue';

@Component({
    components: {
        OtButton,
    },
})
export default class ErrorView extends Vue {}
</script>

<style lang="scss" scoped>
.error {
    display: flex;
    align-items: center;
    height: 100vh;
    width: 100%;
    justify-content: center;
}

.modal-header {
    padding: var(--ot-card-padding);

    display: flex;
    align-items: center;

    &__header{
        margin-bottom: var(--ot-spacing-lg);
        display: flex;

        &__logo {
            max-width: 30%;
            text-align: left;
        }

        &__logout{
            color: var(--ot-color-core-brand);
            margin: auto 0 auto auto;
        }

    }

    &__content {
        text-align: center;
        padding: 0 var(--ot-spacing-xl);
    }
}
</style>
